import React from "react";
import PropTypes from "prop-types";
import { Box, Skeleton } from "@mui/material";
import Card from "./Card";

export const OverviewCardSkeleton = ({ variant }) => {
  if (variant === "welcome") {
    return (
      <Card className="container-card-title">
        <Skeleton width="30%" height={40} />
        <Skeleton width="80%" />
      </Card>
    );
  }

  if (variant === "metrics") {
    return (
      <Card className="card-bigNumbers">
        <Skeleton width={100} sx={{ mb: 1 }} />
        <Skeleton width="60%" height={40} />
      </Card>
    );
  }

  if (variant === "performance") {
    return (
      <Card
        header={{
          hardTitle: <Skeleton width={150} />,
        }}
        style={{ height: "530px", width: "100%" }}
        className="card-menor"
      >
        <Box sx={{ p: 2 }}>
          <Skeleton width="100%" height={50} sx={{ mb: 2 }} />
          <Skeleton width="100%" height={400} variant="rectangular" />
        </Box>
      </Card>
    );
  }

  return (
    <Card
      header={{
        hardTitle: <Skeleton width={150} />,
      }}
      className="card-menor"
      style={{ height: "530px", width: "100%" }}
    >
      <Box sx={{ p: 2 }}>
        <Skeleton width="100%" height={450} variant="rectangular" />
      </Box>
    </Card>
  );
};

OverviewCardSkeleton.propTypes = {
  variant: PropTypes.oneOf(["welcome", "metrics", "performance", "ranking"]),
};
